export default {
  buttonCheckout: {
    id: 'recap_button',
    defaultMessage: 'Checkout',
  },
}
